export { showSearchbar };
const showSearchbar = () => {
  (function ($) {
    $(".search-icon,.searchbar .close").click(function () {
      let searchform = $('#searchInput');
      if (window.innerWidth >= 1200) {
        $(".search-icon").removeClass("d-none");
        $(".searchbar").removeClass("show-mobile");
        $(".searchbar").slideToggle();
        searchform.focus();
      } else {
        $(".search-icon").toggleClass("d-none");
        $(".searchbar").toggleClass("show-mobile");
        searchform.focus();
      }
    });
  })(jQuery);
};
